import { createContext, useContext } from 'react';

// EditorPage provides {register(sectionKey, flushFn), unregister(sectionKey)}.
// Forms may render without a provider (e.g. in isolation) — consumers must
// tolerate null.
const EditorSaveContext = createContext(null);

export const EditorSaveProvider = EditorSaveContext.Provider;
export const useEditorSaveRegistry = () => useContext(EditorSaveContext);
